import {
  generated,
  GetApiDevicesByDeviceTypeImageAndImageIdApiArg,
  GetApiDevicesByDeviceTypeImageAndImageIdApiResponse,
  GetApiDevicesByDeviceTypeImageMetadataAndDeviceIdApiArg,
  GetApiDevicesByDeviceTypeImageMetadataAndDeviceIdApiResponse,
  DeleteApiGatewaysByGatewayIdApiArg,
  DeleteApiGatewaysByGatewayIdApiResponse,
  DeleteApiThermostatsByThermostatIdApiArg,
  DeleteApiThermostatsByThermostatIdApiResponse,
  GetApiGatewaysByGatewayIdApiArg,
  GetApiGatewaysByGatewayIdApiResponse,
  PatchApiGatewaysByGatewayIdApiArg,
  PatchApiGatewaysByGatewayIdApiResponse,
  PatchApiThermostatsByThermostatIdApiArg,
  PatchApiThermostatsByThermostatIdApiResponse,
  GetApiThermostatsByThermostatIdConnectivityApiArg,
  GetApiThermostatsByThermostatIdConnectivityApiResponse,
  GetApiThermostatsByThermostatIdLastmeasurementsApiArg,
  GetApiThermostatsByThermostatIdLastmeasurementsApiResponse,
  GetApiThermostatsByThermostatIdOperationalStatusApiArg,
  GetApiThermostatsByThermostatIdOperationalStatusApiResponse,
  GetApiThermostatsByThermostatIdRenterApiArg,
  GetApiThermostatsByThermostatIdRenterApiResponse,
  PostApiDevelopmentAssemblyLineDetailApiArg,
  PostApiDevelopmentAssemblyLineDetailApiResponse,
  PostApiDevelopmentAssemblyLineSummaryApiArg,
  PostApiDevelopmentAssemblyLineSummaryApiResponse,
  PostApiThermostatsLifecycleTenantUnassignByThermostatEuiApiArg,
  PostApiThermostatsLifecycleTenantUnassignByThermostatEuiApiResponse,
  PostApiThermostatsOperationsByThermostatIdDirectMotorControlDisableApiArg,
  PostApiThermostatsOperationsByThermostatIdDirectMotorControlDisableApiResponse,
  PostApiThermostatsOperationsByThermostatIdDirectMotorControlEnableApiArg,
  PostApiThermostatsOperationsByThermostatIdDirectMotorControlEnableApiResponse,
  PostApiThermostatsOperationsByThermostatIdDisplayRotationApiArg,
  PostApiThermostatsOperationsByThermostatIdDisplayRotationApiResponse,
  PostApiThermostatsOperationsByThermostatIdFlushValveApiArg,
  PostApiThermostatsOperationsByThermostatIdFlushValveApiResponse,
  PostApiThermostatsOperationsByThermostatIdMajorModeApiArg,
  PostApiThermostatsOperationsByThermostatIdMajorModeApiResponse,
  PostApiThermostatsOperationsByThermostatIdManualCalibrationApiArg,
  PostApiThermostatsOperationsByThermostatIdManualCalibrationApiResponse,
  PostApiThermostatsOperationsByThermostatIdMcuResetApiArg,
  PostApiThermostatsOperationsByThermostatIdMcuResetApiResponse,
  PostApiThermostatsOperationsByThermostatIdMotorPositionApiArg,
  PostApiThermostatsOperationsByThermostatIdMotorPositionApiResponse,
  PostApiThermostatsOperationsByThermostatIdMotorPositionConstraintApiArg,
  PostApiThermostatsOperationsByThermostatIdMotorPositionConstraintApiResponse,
  PostApiThermostatsOperationsByThermostatIdTargetTemperatureApiArg,
  PostApiThermostatsOperationsByThermostatIdTargetTemperatureApiResponse,
  PostApiThermostatsOperationsByThermostatIdTargetTemperatureLevelApiArg,
  PostApiThermostatsOperationsByThermostatIdTargetTemperatureLevelApiResponse,
  PostApiThermostatsOperationsByThermostatIdToggleActiveHarvestingAndActivateApiArg,
  PostApiThermostatsOperationsByThermostatIdToggleActiveHarvestingAndActivateApiResponse,
} from './generated';
import { handleFileDownload } from './handleFileDownload';
// import {FetchArgs} from "@reduxjs/toolkit/query/react";

export type DeviceImageUrlResponse = {
  fileName: string;
  storagePath: string;
  thumbnailPath: string;
};

export const apiService = generated
  .injectEndpoints({
    endpoints: (build) => ({
      getApiThermostatsByThermostatIdConnectivity: build.query<
        GetApiThermostatsByThermostatIdConnectivityApiResponse,
        GetApiThermostatsByThermostatIdConnectivityApiArg & { tenantId?: string }
      >({
        query: ({ thermostatId, tenantId }) => ({
          url: `/api/thermostats/${thermostatId}/connectivity`,
          headers: tenantId ? { 'x-tenant-context-id': tenantId } : undefined,
        }),
      }),
      getApiThermostatsByThermostatIdLastmeasurements: build.query<
        GetApiThermostatsByThermostatIdLastmeasurementsApiResponse,
        GetApiThermostatsByThermostatIdLastmeasurementsApiArg & { tenantId?: string }
      >({
        query: ({ thermostatId, tenantId }) => ({
          url: `/api/thermostats/${thermostatId}/lastmeasurements`,
          headers: tenantId ? { 'x-tenant-context-id': tenantId } : undefined,
        }),
      }),
      getApiThermostatsByThermostatIdOperationalStatus: build.query<
        GetApiThermostatsByThermostatIdOperationalStatusApiResponse,
        GetApiThermostatsByThermostatIdOperationalStatusApiArg & { tenantId?: string }
      >({
        query: ({ thermostatId, tenantId }) => ({
          url: `/api/thermostats/${thermostatId}/operational-status`,
          headers: tenantId ? { 'x-tenant-context-id': tenantId } : undefined,
        }),
      }),
      getApiThermostatsByThermostatIdRenter: build.query<
        GetApiThermostatsByThermostatIdRenterApiResponse,
        GetApiThermostatsByThermostatIdRenterApiArg & { tenantId?: string }
      >({
        query: ({ thermostatId, tenantId }) => ({
          url: `/api/thermostats/${thermostatId}/renter`,
          headers: tenantId ? { 'x-tenant-context-id': tenantId } : undefined,
        }),
      }),
      deleteApiThermostatsByThermostatId: build.mutation<
        DeleteApiThermostatsByThermostatIdApiResponse,
        DeleteApiThermostatsByThermostatIdApiArg & { tenantId?: string }
      >({
        query: ({ thermostatId, tenantId }) => ({
          url: `/api/thermostats/${thermostatId}`,
          method: 'DELETE',
          headers: tenantId ? { 'x-tenant-context-id': tenantId } : undefined,
        }),
      }),
      patchApiThermostatsByThermostatId: build.mutation<
        PatchApiThermostatsByThermostatIdApiResponse,
        PatchApiThermostatsByThermostatIdApiArg & { tenantId?: string }
      >({
        query: ({ thermostatId, body, tenantId }) => ({
          url: `/api/thermostats/${thermostatId}`,
          method: 'PATCH',
          body,
          headers: tenantId ? { 'x-tenant-context-id': tenantId } : undefined,
        }),
      }),
      postApiDevelopmentAssemblyLineSummary: build.mutation<
        PostApiDevelopmentAssemblyLineSummaryApiResponse,
        PostApiDevelopmentAssemblyLineSummaryApiArg & { tenantId?: string }
      >({
        query: ({ body, tenantId }) => ({
          url: `/api/development/assembly-line/summary`,
          method: 'POST',
          body: {
            from: body.from,
            to: body.to,
            euis: body.euis,
          },
          responseHandler: handleFileDownload,
          cache: 'no-cache',
          headers: tenantId ? { 'x-tenant-context-id': tenantId } : undefined,
        }),
      }),
      postApiDevelopmentAssemblyLineDetail: build.mutation<
        PostApiDevelopmentAssemblyLineDetailApiResponse,
        PostApiDevelopmentAssemblyLineDetailApiArg & { tenantId?: string }
      >({
        query: ({ body, tenantId }) => ({
          url: `/api/development/assembly-line/detail`,
          method: 'POST',
          body: {
            from: body.from,
            to: body.to,
            euis: body.euis,
          },
          responseHandler: handleFileDownload,
          cache: 'no-cache',
          headers: tenantId ? { 'x-tenant-context-id': tenantId } : undefined,
        }),
      }),
      postApiThermostatsOperationsByThermostatIdDirectMotorControlDisable: build.mutation<
        PostApiThermostatsOperationsByThermostatIdDirectMotorControlDisableApiResponse,
        PostApiThermostatsOperationsByThermostatIdDirectMotorControlDisableApiArg & { tenantId?: string }
      >({
        query: ({ thermostatId, tenantId }) => ({
          url: `/api/thermostats/operations/${thermostatId}/direct-motor-control/disable`,
          method: 'POST',
          headers: tenantId ? { 'x-tenant-context-id': tenantId } : undefined,
        }),
      }),
      postApiThermostatsOperationsByThermostatIdDirectMotorControlEnable: build.mutation<
        PostApiThermostatsOperationsByThermostatIdDirectMotorControlEnableApiResponse,
        PostApiThermostatsOperationsByThermostatIdDirectMotorControlEnableApiArg & { tenantId?: string }
      >({
        query: ({ thermostatId, body, tenantId }) => ({
          url: `/api/thermostats/operations/${thermostatId}/direct-motor-control/enable`,
          method: 'POST',
          body,
          headers: tenantId ? { 'x-tenant-context-id': tenantId } : undefined,
        }),
      }),
      postApiThermostatsOperationsByThermostatIdFlushValve: build.mutation<
        PostApiThermostatsOperationsByThermostatIdFlushValveApiResponse,
        PostApiThermostatsOperationsByThermostatIdFlushValveApiArg & { tenantId?: string }
      >({
        query: ({ thermostatId, tenantId }) => ({
          url: `/api/thermostats/operations/${thermostatId}/flush-valve`,
          method: 'POST',
          headers: tenantId ? { 'x-tenant-context-id': tenantId } : undefined,
        }),
      }),
      postApiThermostatsOperationsByThermostatIdManualCalibration: build.mutation<
        PostApiThermostatsOperationsByThermostatIdManualCalibrationApiResponse,
        PostApiThermostatsOperationsByThermostatIdManualCalibrationApiArg & { tenantId?: string }
      >({
        query: ({ thermostatId, tenantId }) => ({
          url: `/api/thermostats/operations/${thermostatId}/manual-calibration`,
          method: 'POST',
          headers: tenantId ? { 'x-tenant-context-id': tenantId } : undefined,
        }),
      }),
      postApiThermostatsOperationsByThermostatIdMcuReset: build.mutation<
        PostApiThermostatsOperationsByThermostatIdMcuResetApiResponse,
        PostApiThermostatsOperationsByThermostatIdMcuResetApiArg & { tenantId?: string }
      >({
        query: ({ thermostatId, tenantId }) => ({
          url: `/api/thermostats/operations/${thermostatId}/mcu-reset`,
          method: 'POST',
          headers: tenantId ? { 'x-tenant-context-id': tenantId } : undefined,
        }),
      }),
      postApiThermostatsOperationsByThermostatIdDisplayRotation: build.mutation<
        PostApiThermostatsOperationsByThermostatIdDisplayRotationApiResponse,
        PostApiThermostatsOperationsByThermostatIdDisplayRotationApiArg & { tenantId?: string }
      >({
        query: ({ thermostatId, body, tenantId }) => ({
          url: `/api/thermostats/operations/${thermostatId}/display-rotation`,
          method: 'POST',
          body,
          headers: tenantId ? { 'x-tenant-context-id': tenantId } : undefined,
        }),
      }),
      postApiThermostatsOperationsByThermostatIdMajorMode: build.mutation<
        PostApiThermostatsOperationsByThermostatIdMajorModeApiResponse,
        PostApiThermostatsOperationsByThermostatIdMajorModeApiArg & { tenantId?: string }
      >({
        query: ({ thermostatId, body, tenantId }) => ({
          url: `/api/thermostats/operations/${thermostatId}/major-mode`,
          method: 'POST',
          body,
          headers: tenantId ? { 'x-tenant-context-id': tenantId } : undefined,
        }),
      }),
      postApiThermostatsOperationsByThermostatIdMotorPositionConstraint: build.mutation<
        PostApiThermostatsOperationsByThermostatIdMotorPositionConstraintApiResponse,
        PostApiThermostatsOperationsByThermostatIdMotorPositionConstraintApiArg & { tenantId?: string }
      >({
        query: ({ thermostatId, body, tenantId }) => ({
          url: `/api/thermostats/operations/${thermostatId}/motor-position-constraint`,
          method: 'POST',
          body,
          headers: tenantId ? { 'x-tenant-context-id': tenantId } : undefined,
        }),
      }),
      postApiThermostatsOperationsByThermostatIdMotorPosition: build.mutation<
        PostApiThermostatsOperationsByThermostatIdMotorPositionApiResponse,
        PostApiThermostatsOperationsByThermostatIdMotorPositionApiArg & { tenantId?: string }
      >({
        query: ({ thermostatId, body, tenantId }) => ({
          url: `/api/thermostats/operations/${thermostatId}/motor-position`,
          method: 'POST',
          body,
          headers: tenantId ? { 'x-tenant-context-id': tenantId } : undefined,
        }),
      }),
      postApiThermostatsOperationsByThermostatIdTargetTemperature: build.mutation<
        PostApiThermostatsOperationsByThermostatIdTargetTemperatureApiResponse,
        PostApiThermostatsOperationsByThermostatIdTargetTemperatureApiArg & { tenantId?: string }
      >({
        query: ({ thermostatId, body, tenantId }) => ({
          url: `/api/thermostats/operations/${thermostatId}/target-temperature`,
          method: 'POST',
          body,
          headers: tenantId ? { 'x-tenant-context-id': tenantId } : undefined,
        }),
      }),
      postApiThermostatsOperationsByThermostatIdTargetTemperatureLevel: build.mutation<
        PostApiThermostatsOperationsByThermostatIdTargetTemperatureLevelApiResponse,
        PostApiThermostatsOperationsByThermostatIdTargetTemperatureLevelApiArg & { tenantId?: string }
      >({
        query: ({ thermostatId, body, tenantId }) => ({
          url: `/api/thermostats/operations/${thermostatId}/target-temperature-level`,
          method: 'POST',
          body,
          headers: tenantId ? { 'x-tenant-context-id': tenantId } : undefined,
        }),
      }),
      postApiThermostatsOperationsByThermostatIdToggleActiveHarvestingAndActivate: build.mutation<
        PostApiThermostatsOperationsByThermostatIdToggleActiveHarvestingAndActivateApiResponse,
        PostApiThermostatsOperationsByThermostatIdToggleActiveHarvestingAndActivateApiArg & { tenantId?: string }
      >({
        query: ({ thermostatId, activate, tenantId }) => ({
          url: `/api/thermostats/operations/${thermostatId}/toggle-active-harvesting/${activate}`,
          method: 'POST',
          headers: tenantId ? { 'x-tenant-context-id': tenantId } : undefined,
        }),
      }),
      postApiThermostatsLifecycleTenantUnassignByThermostatEui: build.mutation<
        PostApiThermostatsLifecycleTenantUnassignByThermostatEuiApiResponse,
        PostApiThermostatsLifecycleTenantUnassignByThermostatEuiApiArg & { tenantId?: string }
      >({
        query: ({ thermostatEui, tenantId }) => ({
          url: `/api/thermostats/lifecycle/tenant-unassign/${thermostatEui}`,
          method: 'POST',
          headers: tenantId ? { 'x-tenant-context-id': tenantId } : undefined,
        }),
      }),
      getApiDevicesByDeviceTypeImageAndImageId: build.query<
        GetApiDevicesByDeviceTypeImageAndImageIdApiResponse,
        GetApiDevicesByDeviceTypeImageAndImageIdApiArg & { tenantId?: string }
      >({
        // Image doesn't need invalidating if id doesn't change — every image id maps to the same image.
        query: ({ deviceType, imageId, tenantId }) => ({
          url: `/api/devices/${deviceType}/image/${imageId}`,
          responseHandler: (response: Response) => response.json() as Promise<DeviceImageUrlResponse>,
          headers: tenantId ? { 'x-tenant-context-id': tenantId } : undefined,
        }),
      }),
      getApiDevicesByDeviceTypeImageMetadataAndDeviceId: build.query<
        GetApiDevicesByDeviceTypeImageMetadataAndDeviceIdApiResponse,
        GetApiDevicesByDeviceTypeImageMetadataAndDeviceIdApiArg & { tenantId?: string }
      >({
        query: ({ deviceType, deviceId, tenantId }) => ({
          url: `/api/devices/${deviceType}/image-metadata/${deviceId}`,
          headers: tenantId ? { 'x-tenant-context-id': tenantId } : undefined,
        }),
      }),
      getApiGatewaysByGatewayId: build.query<GetApiGatewaysByGatewayIdApiResponse, GetApiGatewaysByGatewayIdApiArg & { tenantId?: string }>(
        {
          query: ({ gatewayId, tenantId }) => ({
            url: `/api/gateways/${gatewayId}`,
            headers: tenantId ? { 'x-tenant-context-id': tenantId } : undefined,
          }),
        },
      ),
      deleteApiGatewaysByGatewayId: build.mutation<
        DeleteApiGatewaysByGatewayIdApiResponse,
        DeleteApiGatewaysByGatewayIdApiArg & { tenantId?: string }
      >({
        query: ({ gatewayId, tenantId }) => ({
          url: `/api/gateways/${gatewayId}`,
          method: 'DELETE',
          headers: tenantId ? { 'x-tenant-context-id': tenantId } : undefined,
        }),
      }),
      patchApiGatewaysByGatewayId: build.mutation<
        PatchApiGatewaysByGatewayIdApiResponse,
        PatchApiGatewaysByGatewayIdApiArg & { tenantId?: string }
      >({
        query: ({ gatewayId, body, tenantId }) => ({
          url: `/api/gateways/${gatewayId}`,
          method: 'PATCH',
          body,
          headers: tenantId ? { 'x-tenant-context-id': tenantId } : undefined,
        }),
      }),
    }),
    overrideExisting: true,
  })
  .enhanceEndpoints({
    addTagTypes: [
      'Tenant',
      'Room',
      'RoomWindows',
      'Gateway',
      'GatewayInstallationIssue',
      'Thermostat',
      'Sensor',
      'Levels',
      'Location',
      'Taxonomy',
      'TaxonomyViewLocation',
      'TaxonomyViewBuildingUnit',
      'HeatingCircuit',
      'Radiator',
      'InstallToolNote',
      'InstallToolRoom',
      'InstallToolRadiator',
      'InstallToolBuildingByFloors',
      'InstallToolBuildingByHours',
      'InstallToolBuildingUnit',
      'BuildingUnit',
      'Building',
      'Lease',
      'ThermostatMeasurements',
      'SignalTester',
      'Agreement',
      'RenterVerification',

      'Projects',
      'ProjectManagement',
      'ProjectDetail',
      'ProjectBuildings',
      'ProjectUsers',
      'ProjectIssues',

      'ThermostatAutocomplete',
      'SensorAutocomplete',

      'FirmwareCore',
      'TermiosApp',
      'DataTransferToDevice',
      'DataTransferFromDevice',
      'FirmwareDashboard',
      'AdminAppSettings',

      'AutoFuota',
      'DataTransferToDeviceBatches',
      'Phase',
      'DevicePhoto',
      'Organization',
      'HeatingClamps',
    ],
    endpoints: {
      // Tenant-related endpoints
      getApiTenants: { providesTags: ['Tenant'] },
      getApiTenantsByTenantId: { providesTags: ['Tenant'] },
      getApiTenantsAutocomplete: { providesTags: ['Tenant'] },
      getApiTenantsByTenantIdOverview: { providesTags: ['Tenant'] },
      postApiTenants: { invalidatesTags: ['Tenant'] },
      patchApiTenantsByTenantId: { invalidatesTags: ['Tenant'] },

      // Gateway-related endpoints
      deleteApiGatewaysByGatewayId: { invalidatesTags: ['Gateway'] },
      getApiGateways: { providesTags: ['Gateway'] },
      getApiGatewaysByGatewayId: { providesTags: ['Gateway'] },
      patchApiGatewaysByGatewayId: { invalidatesTags: ['Gateway'] },
      postApiGateways: { invalidatesTags: ['Gateway'] },
      postApiGatewaysAssignByGatewayId: { invalidatesTags: ['Gateway', 'Building'] },
      postApiGatewaysUnassignByGatewayId: { invalidatesTags: ['Gateway', 'Building', 'DevicePhoto'] },
      getApiGatewaysSpaceBySpaceId: { providesTags: ['Gateway'] },
      getApiGatewaysAutocomplete: { providesTags: ['Gateway'] },
      getApiInstallToolGatewaysBuildings: { providesTags: ['Gateway', 'GatewayInstallationIssue', 'Building', 'SignalTester'] },
      patchApiGatewaysByGatewayIdInstallationProcess: { invalidatesTags: ['Gateway'] },
      getApiInstallToolGatewaysBuildingsByBuildingId: { providesTags: ['Gateway', 'Building', 'SignalTester'] },
      patchApiInstallToolGatewaysBuildingsByBuildingId: { invalidatesTags: ['Building'] },

      getApiTaxonomyBuildingsByBuildingIdGatewaySignalTest: { providesTags: ['SignalTester'] },
      patchApiTaxonomyBuildingsByBuildingIdGatewaySignalTestFloor: { invalidatesTags: ['SignalTester'] },
      postApiTaxonomyBuildingsByBuildingIdGatewaySignalTest: { invalidatesTags: ['SignalTester'] },

      // Gateway Installation Issue-related endpoints
      patchApiTaxonomyBuildingsByBuildingIdGatewayIssues: { invalidatesTags: ['GatewayInstallationIssue'] },
      getApiTaxonomyBuildingsByBuildingIdGatewayIssues: { providesTags: ['GatewayInstallationIssue'] },

      // Thermostat-related endpoints
      deleteApiThermostatsByThermostatId: { invalidatesTags: ['Thermostat'] },
      getApiThermostats: { providesTags: ['Thermostat'] },
      getApiThermostatsByThermostatId: { providesTags: ['Thermostat'] },
      getApiThermostatsThermostatHistory: { extraOptions: { skipTenantContext: true } },
      getApiThermostatsThermostatHistoryRadiators: { extraOptions: { skipTenantContext: true } },
      getApiThermostatsDownlinks: { extraOptions: { skipTenantContext: true } },
      getApiThermostatsAssemblyLineHistoryByEui: { extraOptions: { skipTenantContext: true } },
      getApiAlertsThermostats: { extraOptions: { skipTenantContext: true } },
      getApiThermostatsSpaceBySpaceId: { providesTags: ['Thermostat'] },
      patchApiThermostatsByThermostatId: { invalidatesTags: ['Thermostat'] },
      postApiThermostatsLifecycleTenantUnassignByThermostatEui: { invalidatesTags: ['Thermostat'] },
      postApiThermostatsReportMalfunctionByThermostatId: {
        invalidatesTags: [
          'Thermostat',
          'InstallToolBuildingUnit',
          'InstallToolBuildingByFloors',
          'InstallToolBuildingByHours',
          'InstallToolRoom',
          'InstallToolRadiator',
          'DevicePhoto',
        ],
      },

      // Sensor-related endpoints
      deleteApiSensorsBySensorId: { invalidatesTags: ['Sensor'] },
      getApiSensors: { providesTags: ['Sensor'] },
      getApiSensorsBySensorId: { providesTags: ['Sensor'] },
      getApiSensorsSpaceBySpaceId: { providesTags: ['Sensor'] },
      patchApiSensorsBySensorId: { invalidatesTags: ['Sensor'] },
      postApiSensors: { invalidatesTags: ['Sensor'] },
      postApiSensorsUnassignBySensorId: { invalidatesTags: ['Sensor', 'InstallToolBuildingUnit', 'RoomWindows'] },
      postApiSensorsAssignWindowBySensorId: {
        invalidatesTags: [
          'Sensor',
          'RoomWindows',
          'InstallToolBuildingUnit',
          'InstallToolRoom',
          'SensorAutocomplete',
          'ThermostatAutocomplete',
        ],
      },
      postApiSensorsAssignSpaceBySensorId: {
        invalidatesTags: ['Sensor', 'InstallToolRoom', 'InstallToolBuildingUnit', 'SensorAutocomplete'],
      },
      postApiSensorsPairBySensorId: { invalidatesTags: ['Sensor'] },
      postApiSensorsUnpairBySensorId: { invalidatesTags: ['Sensor'] },
      postApiSensorsPairSpaceBySpaceId: { invalidatesTags: ['Sensor'] },
      postApiSensorsUnpairSpaceBySpaceId: { invalidatesTags: ['Sensor'] },

      // Levels-related endpoints
      getApiTaxonomyBuildingComplexesByBuildingComplexId: { providesTags: ['Levels'] },
      postApiTaxonomyBuildingComplexes: { invalidatesTags: ['Location'] },

      // Location and Taxonomy-related endpoints
      getApiTaxonomyLocations: { providesTags: ['Location'] },
      getApiTaxonomyLocationsByLocationId: { providesTags: ['Location'] },
      patchApiTaxonomyLocationsByLocationId: { invalidatesTags: ['Location'] },
      postApiTaxonomyLocations: { invalidatesTags: ['Location'] },
      getApiTaxonomyViewLocation: { providesTags: ['TaxonomyViewLocation'] },
      getApiHeatingLoadByBuildingIdCompletionStatistic: { keepUnusedDataFor: 0 },
      deleteApiTaxonomyBuildingComplexesByBuildingComplexId: { invalidatesTags: ['Location'] },
      deleteApiTaxonomyLocationsByLocationId: { invalidatesTags: ['Location'] },

      // Temporary fix. Should be changed after new location design is implemented
      postApiTaxonomyAssignedHeatingCircuitBySpaceId: { invalidatesTags: ['Taxonomy'] },
      postApiTaxonomyAssignedFloorsBySpaceId: { invalidatesTags: ['Taxonomy'] },
      patchApiTaxonomyRenameBySpaceId: { invalidatesTags: ['Taxonomy'] },
      postApiTaxonomyResetHeatingCircuitBySpaceId: { invalidatesTags: ['Taxonomy'] },

      // Data Agreement-related endpoints
      getApiOptIn: { providesTags: ['Agreement'] },
      postApiOptIn: { invalidatesTags: ['Agreement', 'Lease'] },
      getApiDataPrivacy: { providesTags: ['Agreement'] },
      postApiDataPrivacy: { invalidatesTags: ['Agreement'] },
      getApiLegalNote: { providesTags: ['Agreement'] },
      postApiLegalNote: { invalidatesTags: ['Agreement'] },
      getApiTermsOfUse: { providesTags: ['Agreement'] },
      postApiTermsOfUse: { invalidatesTags: ['Agreement'] },

      // Heating Circuit-related endpoints
      deleteApiTaxonomyLocationsByLocationIdHeatingCircuitsAndHeatingCircuitId: { invalidatesTags: ['HeatingCircuit'] },
      getApiTaxonomyLocationsByLocationIdHeatingCircuits: { providesTags: ['HeatingCircuit'] },
      patchApiTaxonomyLocationsByLocationIdHeatingCircuitsAndHeatingCircuitId: { invalidatesTags: ['HeatingCircuit'] },
      postApiTaxonomyLocationsByLocationIdHeatingCircuits: { invalidatesTags: ['HeatingCircuit'] },

      // Taxonomy Radiator-related endpoints
      getApiTaxonomyRadiatorsByRadiatorId: { providesTags: ['Radiator', 'InstallToolRadiator'] },
      getApiTaxonomyViewBuildingUnitByBuildingUnitId: { providesTags: ['TaxonomyViewBuildingUnit'] },

      // Taxonomy Building-related endpoints
      getApiTaxonomyBuildingsByBuildingId: { providesTags: ['Building', 'Gateway'] },
      patchApiTaxonomyBuildingsByBuildingId: {
        invalidatesTags: ['TaxonomyViewLocation', 'Building'],
      },
      postApiTaxonomyBuildings: {
        invalidatesTags: ['TaxonomyViewLocation'],
      },

      // Taxonomy Building Unit - related endpoints
      patchApiTaxonomyBuildingUnitsByBuildingUnitId: {
        invalidatesTags: ['TaxonomyViewLocation', 'BuildingUnit'],
      },
      postApiTaxonomyBuildingUnits: {
        invalidatesTags: ['TaxonomyViewLocation'],
      },

      patchApiTaxonomyRadiatorsByRadiatorIdChecklist: {
        invalidatesTags: ['InstallToolRadiator'],
      },

      getApiDevicesByDeviceTypeImageMetadataAndDeviceId: { providesTags: ['DevicePhoto'] },

      // Lease endpoints
      getApiLeasesBuildingUnitByBuildingUnitId: {
        providesTags: ['Lease'],
      },
      getApiLeasesBuildingUnitByBuildingUnitIdActive: {
        providesTags: ['Lease'],
      },
      postApiLeases: {
        invalidatesTags: ['Lease', 'InstallToolBuildingUnit', 'RenterVerification'],
      },
      deleteApiLeasesByLeaseId: {
        invalidatesTags: ['Lease', 'InstallToolBuildingUnit', 'RenterVerification'],
      },
      patchApiLeasesByLeaseId: {
        invalidatesTags: ['Lease', 'InstallToolBuildingUnit', 'RenterVerification'],
      },

      // Project-related endpoints
      getApiProjects: { providesTags: ['Projects'] },
      getApiProjectsDetailByProjectId: { providesTags: ['ProjectDetail'] },

      getApiProjectsDetailByProjectIdUsers: { providesTags: ['ProjectUsers'] },
      getApiProjectsDetailByProjectIdBuildings: { providesTags: ['ProjectBuildings'] },

      getApiProjectsIssuesByProjectIdBuildingUnits: { providesTags: ['ProjectIssues'] },
      getApiProjectsIssuesByProjectIdRooms: { providesTags: ['ProjectIssues'] },
      getApiProjectsIssuesByProjectIdRadiators: { providesTags: ['ProjectIssues'] },
      getApiProjectsIssuesByProjectIdThermostats: { providesTags: ['ProjectIssues'] },
      getApiProjectsIssuesByProjectIdRenters: { providesTags: ['ProjectIssues'] },

      getApiProjectsManagementByProjectId: { providesTags: ['ProjectManagement'] },
      patchApiProjectsManagementByProjectId: { invalidatesTags: ['Projects', 'ProjectManagement', 'ProjectDetail'] },
      postApiProjectsManagement: { invalidatesTags: ['Projects'] },
      deleteApiProjectsManagementByProjectId: { invalidatesTags: ['Projects'] },

      getApiProjectsManagementByProjectIdAvailableBuildings: { providesTags: ['ProjectBuildings'] },
      postApiProjectsManagementByProjectIdAssignBuildings: {
        invalidatesTags: ['ProjectBuildings', 'ProjectManagement', 'Projects', 'ProjectDetail'],
      },
      postApiProjectsManagementByProjectIdUnassignBuildings: { invalidatesTags: ['ProjectBuildings', 'ProjectManagement', 'Projects'] },

      getApiProjectsManagementByProjectIdAvailableUsers: { providesTags: ['ProjectUsers'] },
      postApiProjectsManagementByProjectIdAssignUsers: { invalidatesTags: ['ProjectUsers', 'ProjectManagement', 'Projects'] },
      postApiProjectsManagementByProjectIdUnassignUsers: { invalidatesTags: ['ProjectUsers', 'ProjectManagement', 'Projects'] },

      getApiProjectsSyncByProjectIdRenowate: { providesTags: ['ProjectDetail'] },
      postApiProjectsSyncByProjectIdRenowate: { invalidatesTags: ['Projects'] },

      // Install Tool Note-related endpoints
      getApiTaxonomyBuildingUnitsByBuildingUnitId: { providesTags: ['InstallToolNote', 'BuildingUnit'] },
      getApiTaxonomyRoomsByRoomId: { providesTags: ['InstallToolNote', 'InstallToolRoom'] },

      // Install Tool Room-related endpoints
      getApiInstallToolRoomsByRoomId: { providesTags: ['InstallToolRoom', 'InstallToolNote', 'Sensor'] },
      patchApiTaxonomyRoomsByRoomId: {
        invalidatesTags: ['InstallToolRoom', 'Room', 'ThermostatAutocomplete', 'TaxonomyViewBuildingUnit'],
      }, // TBD: This could be optimized

      // Install Tool Radiator-related endpoints
      getApiInstallToolRadiatorsByRadiatorId: { providesTags: ['InstallToolRadiator', 'InstallToolNote'] },
      postApiTaxonomyRadiators: { invalidatesTags: ['InstallToolRoom', 'InstallToolBuildingUnit', 'TaxonomyViewBuildingUnit'] },
      patchApiTaxonomyRadiatorsByRadiatorId: {
        invalidatesTags: ['Radiator', 'InstallToolRoom', 'InstallToolBuildingUnit', 'InstallToolRadiator', 'TaxonomyViewBuildingUnit'], // TBD: This could be optimized
      },
      patchApiTaxonomyRadiatorsByRadiatorIdInstallationFailed: { invalidatesTags: ['InstallToolRadiator', 'Radiator', 'Thermostat'] },
      deleteApiTaxonomyRadiatorsByRadiatorId: { invalidatesTags: ['InstallToolBuildingUnit', 'InstallToolRoom'] },
      patchApiTaxonomyRadiatorsByRadiatorIdObstruction: { invalidatesTags: ['InstallToolRadiator', 'Radiator', 'InstallToolRoom'] },
      deleteApiTaxonomyRadiatorsByRadiatorIdObstruction: { invalidatesTags: ['InstallToolRadiator', 'Radiator'] },
      patchApiTaxonomyRadiatorsByRadiatorIdVenting: { invalidatesTags: ['InstallToolRadiator'] },
      getApiTaxonomyRadiatorsByRadiatorIdSpecification: { providesTags: ['Radiator'] },
      putApiTaxonomyRadiatorsByRadiatorIdSpecification: { invalidatesTags: ['Radiator', 'InstallToolRadiator'] },

      // Install Tool Building-related endpoints
      // getApiInstallToolBuildingsByBuildingId: { providesTags: ['InstallToolBuilding'] },
      getApiInstallToolBuildingByFloorsByBuildingId: { providesTags: ['InstallToolBuildingByFloors'] },
      // getApiInstallToolBuildingByHoursByBuildingId: { providesTags: ['InstallToolBuildingByHours'] }, // TODO remove

      // Install App BUILDING Unit Status-related endpoints
      getApiInstallToolBuildingUnitsByBuildingUnitId: {
        providesTags: ['InstallToolBuildingUnit', 'Room', 'InstallToolNote', 'Sensor'],
      },
      getApiInstallToolAppointmentsByProjectId: { providesTags: ['InstallToolBuildingByHours'] },

      patchApiTaxonomyBuildingUnitsByBuildingUnitIdStatus: {
        invalidatesTags: ['InstallToolBuildingUnit', 'InstallToolBuildingByFloors', 'InstallToolBuildingByHours'],
      },
      postApiRentersByRenterIdAgreementInfoReceived: {
        async onQueryStarted({ renterId }, { dispatch, queryFulfilled, getState }) {
          const state = getState();
          const allCachedArgs = generated.util.selectCachedArgsForQuery(state, 'getApiInstallToolBuildingUnitsByBuildingUnitId');

          const patchResults = allCachedArgs.map((args) => {
            return dispatch(
              generated.util.updateQueryData('getApiInstallToolBuildingUnitsByBuildingUnitId', args, (draft) => {
                if (draft.lease?.renter && draft.lease.renter.id === renterId) {
                  draft.lease.renter.infoReceivedAgreement = true;
                }
              }),
            );
          });

          try {
            await queryFulfilled;
          } catch {
            // Undo optimistic updates on error
            patchResults.forEach((patch) => patch.undo());
          }
        },
      },

      // INVALIDATE INSTALL TOOL DESCRIPTION PATCH
      patchApiTaxonomyDescriptionBySpaceId: { invalidatesTags: ['InstallToolNote', 'Radiator'] },

      // Additional endpoints
      postApiThermostatsAssignByThermostatId: {
        invalidatesTags: [
          'InstallToolBuildingUnit',
          'InstallToolRadiator',
          'Radiator',
          'ThermostatAutocomplete',
          'Thermostat',
          'DevicePhoto',
        ],
      },
      postApiThermostatsUnassignByThermostatId: {
        invalidatesTags: ['InstallToolBuildingUnit', 'InstallToolRadiator', 'Radiator', 'Thermostat', 'DevicePhoto'],
      },

      // Room-related endpoints
      postApiTaxonomyRooms: { invalidatesTags: ['Room', 'TaxonomyViewBuildingUnit'] },

      // Windows-related endpoints
      getApiTaxonomyRoomsByRoomIdWindows: { providesTags: ['RoomWindows'] },
      getApiTaxonomyRoomsByRoomIdWindowsAndWindowId: { providesTags: ['RoomWindows'] },
      postApiTaxonomyRoomsByRoomIdWindows: { invalidatesTags: ['RoomWindows', 'Room', 'InstallToolRoom'] },
      deleteApiTaxonomyRoomsByRoomIdWindowsAndWindowId: { invalidatesTags: ['RoomWindows', 'Room', 'InstallToolRoom'] },

      // Search autocomplete
      getApiThermostatsAutocomplete: { providesTags: ['ThermostatAutocomplete'] },
      getApiSensorsAutocomplete: { providesTags: ['SensorAutocomplete'] },

      // Artifact store
      getApiDevelopmentArtifactsFirmwareCore: { providesTags: ['FirmwareCore'] },
      getApiDevelopmentArtifactsTermiosApp: { providesTags: ['TermiosApp'] },
      deleteApiDevelopmentArtifactsFirmwareCoreByMajorAndMinorPatch: { invalidatesTags: ['FirmwareCore'] },
      deleteApiDevelopmentArtifactsTermiosAppByAppIdAndMajorMinorPatch: { invalidatesTags: ['TermiosApp'] },

      // Data transfer
      getApiDevelopmentDataTransferToDevice: { providesTags: ['DataTransferToDevice'] },
      getApiDevelopmentDataTransferFromDeviceTransfers: { providesTags: ['DataTransferFromDevice'] },
      getApiDevelopmentFirmwareUpdateDashboard: { providesTags: ['FirmwareCore', 'FirmwareDashboard'] },
      postApiDevelopmentDataTransferToDeviceByThermostatIdUploadCoreAndMajorMinorPatch: { invalidatesTags: ['DataTransferToDevice'] },
      postApiDevelopmentDataTransferToDeviceByThermostatIdUploadCoreByKeyAndKey: { invalidatesTags: ['DataTransferToDevice'] },
      postApiDevelopmentDataTransferToDeviceByThermostatIdUploadAppAndAppIdMajorMinorPatch: { invalidatesTags: ['DataTransferToDevice'] },
      postApiDevelopmentDataTransferToDeviceAbortByThermostatId: { invalidatesTags: ['DataTransferToDevice'] },
      postApiDevelopmentFirmwareUpdateDashboard: { invalidatesTags: ['DataTransferToDevice', 'FirmwareDashboard'] },
      postApiDevelopmentDataTransferFromDeviceByThermostatIdFlash: { invalidatesTags: ['DataTransferFromDevice'] },
      postApiDevelopmentDataTransferFromDeviceByThermostatIdLogs: { invalidatesTags: ['DataTransferFromDevice'] },
      postApiDevelopmentDataTransferFromDeviceByThermostatIdRam: { invalidatesTags: ['DataTransferFromDevice'] },

      // Admin App Settings
      getApiSettings: { providesTags: ['AdminAppSettings'] },
      putApiSettingsByCodeAndValue: { invalidatesTags: ['AdminAppSettings'] },

      // Admin App Thermostat Sidebar
      getApiThermostatsByThermostatIdLastmeasurements: { providesTags: ['ThermostatMeasurements'] },
      postApiThermostatsOperationsByThermostatIdDirectMotorControlDisable: { invalidatesTags: ['Thermostat'] },
      postApiThermostatsOperationsByThermostatIdDirectMotorControlEnable: { invalidatesTags: ['Thermostat'] },

      // AutoFuota
      deleteApiDevelopmentAutoFuotaByAutoFuotaId: { invalidatesTags: ['AutoFuota'] },
      getApiDevelopmentAutoFuota: { providesTags: ['AutoFuota', 'DataTransferToDevice'] },

      postApiDevelopmentOnboardingThermostats: {
        query: (request) => {
          const bodyFormData = new FormData();
          if (request.body.TenantId) bodyFormData.append('TenantId', request.body.TenantId);
          if (request.body.ChirpstackApplicationId) bodyFormData.append('ChirpstackApplicationId', request.body.ChirpstackApplicationId);
          if (request.body.ChirpstackDeviceProfileId)
            bodyFormData.append('ChirpstackDeviceProfileId', request.body.ChirpstackDeviceProfileId);
          bodyFormData.append('SkipChirpstack', request.body.SkipChirpstack ? 'true' : 'false');
          bodyFormData.append('SkipAdminApp', request.body.SkipAdminApp ? 'true' : 'false');
          if (request.body.File) bodyFormData.append('File', request.body.File);
          return {
            url: '/api/development/onboarding/thermostats',
            method: 'POST',
            body: bodyFormData,
          };
        },
        invalidatesTags: ['Thermostat'],
      },

      postApiDevelopmentOnboardingSensors: {
        query: (request) => {
          const bodyFormData = new FormData();
          if (request.body.ChirpstackApplicationId) bodyFormData.append('ChirpstackApplicationId', request.body.ChirpstackApplicationId);
          if (request.body.ChirpstackDeviceProfileId)
            bodyFormData.append('ChirpstackDeviceProfileId', request.body.ChirpstackDeviceProfileId);
          if (request.body.SensorType) bodyFormData.append('SensorType', request.body.SensorType);
          bodyFormData.append('SkipChirpstack', request.body.SkipChirpstack ? 'true' : 'false');
          bodyFormData.append('SkipAdminApp', request.body.SkipAdminApp ? 'true' : 'false');
          if (request.body.File) bodyFormData.append('File', request.body.File);
          return {
            url: '/api/development/onboarding/sensors',
            method: 'POST',
            body: bodyFormData,
          };
        },
        invalidatesTags: ['Sensor'],
      },

      postApiDevelopmentOnboardingSignalTesters: {
        query: (request) => {
          const bodyFormData = new FormData();
          if (request.body.ChirpstackApplicationId) bodyFormData.append('ChirpstackApplicationId', request.body.ChirpstackApplicationId);
          if (request.body.ChirpstackDeviceProfileId)
            bodyFormData.append('ChirpstackDeviceProfileId', request.body.ChirpstackDeviceProfileId);
          bodyFormData.append('SkipChirpstack', request.body.SkipChirpstack ? 'true' : 'false');
          bodyFormData.append('SkipAdminApp', request.body.SkipAdminApp ? 'true' : 'false');
          if (request.body.File) bodyFormData.append('File', request.body.File);
          return {
            url: '/api/development/onboarding/signal-testers',
            method: 'POST',
            body: bodyFormData,
          };
        },
        invalidatesTags: ['SignalTester'],
      },

      postApiDevelopmentDataTransferToDeviceByThermostatIdUploadBinary: {
        query: (request) => {
          const bodyFormData = new FormData();
          if (request.body.TransferType) bodyFormData.append('TransferType', request.body.TransferType);
          bodyFormData.append('Name', request.body.Name ?? '');

          if (request.body.File) bodyFormData.append('File', request.body.File);
          return {
            url: `/api/development/data-transfer-to-device/${request.thermostatId}/upload-binary`,
            method: 'POST',
            body: bodyFormData,
          };
        },
        invalidatesTags: ['DataTransferToDevice'],
      },

      postApiDevelopmentDataTransferToDeviceBulkUploadBinaryByBuildingId: {
        query: (request) => {
          const { body, buildingId, ...params } = request;

          const bodyFormData = new FormData();
          if (body.TransferType) bodyFormData.append('TransferType', body.TransferType);
          bodyFormData.append('Name', body.Name ?? '');

          const url = new URL(`/api/development/data-transfer-to-device/bulk-upload-binary/${buildingId}`);

          if (request.body.File) bodyFormData.append('File', request.body.File);
          return {
            url: url.toString(),
            params: params,
            method: 'POST',
            body: bodyFormData,
          };
        },
      },

      getApiFilesFileTemplateByTemplate: {
        query: (request) => {
          return {
            url: `/api/files/file-template/${request.template}`,
            method: 'GET',
            responseHandler: handleFileDownload,
            cache: 'no-cache',
          };
        },
      },

      getApiDevelopmentDataTransferFromDeviceByTransferIdDownload: {
        query: (request) => {
          return {
            url: `/api/development/data-transfer-from-device/${request.transferId}/download`,
            method: 'GET',
            responseHandler: handleFileDownload,
            cache: 'no-cache',
          };
        },
      },

      postApiDevelopmentArtifactsFirmwareCore: {
        invalidatesTags: ['FirmwareCore'],
        query: (request) => {
          const bodyFormData = new FormData();
          if (request.body['MainFile.File']) bodyFormData.append('MainFile.File', request.body['MainFile.File']);
          if (request.body['MainFile.Signature']) bodyFormData.append('MainFile.Signature', request.body['MainFile.Signature']);
          if (request.body['CompressedFile.File']) bodyFormData.append('CompressedFile.File', request.body['CompressedFile.File']);
          if (request.body['CompressedFile.Signature'])
            bodyFormData.append('CompressedFile.Signature', request.body['CompressedFile.Signature']);
          return {
            url: '/api/development/artifacts/firmware-core',
            method: 'POST',
            body: bodyFormData,
          };
        },
      },

      postApiDevelopmentArtifactsTermiosApp: {
        invalidatesTags: ['TermiosApp'],
        query: (request) => {
          const bodyFormData = new FormData();
          if (request.body['MainFile.File']) bodyFormData.append('MainFile.File', request.body['MainFile.File']);
          if (request.body['MainFile.Signature']) bodyFormData.append('MainFile.Signature', request.body['MainFile.Signature']);
          if (request.body['CompressedFile.File']) bodyFormData.append('CompressedFile.File', request.body['CompressedFile.File']);
          if (request.body['CompressedFile.Signature'])
            bodyFormData.append('CompressedFile.Signature', request.body['CompressedFile.Signature']);
          return {
            url: '/api/development/artifacts/termios-app',
            method: 'POST',
            body: bodyFormData,
          };
        },
      },

      patchApiDataPrivacySiteByDataPrivacyAgreementId: {
        async onQueryStarted({ dataPrivacyAgreementId, body }, { dispatch, queryFulfilled, getState }) {
          // Get all cached args for this endpoint
          const state = getState();
          const allCachedArgs = generated.util.selectCachedArgsForQuery(state, 'getApiDataPrivacySiteFilter');

          // Keep a list of patchResults to undo if needed
          const patchResults = allCachedArgs.map((args) => {
            return dispatch(
              generated.util.updateQueryData('getApiDataPrivacySiteFilter', args, (draft) => {
                // Update matching record based on ID
                draft.items?.forEach((item) => {
                  if (item.id === dataPrivacyAgreementId) {
                    item.processed = body.processed;
                  }
                });
              }),
            );
          });

          try {
            await queryFulfilled;
          } catch {
            // Undo optimistic updates on error
            patchResults.forEach((patch) => patch.undo());
          }
        },
      },
      patchApiTaxonomyBuildingComplexesByBuildingComplexId: {
        async onQueryStarted({ buildingComplexId, body, ...patch }, { dispatch, queryFulfilled, getState }) {
          const state = getState();
          // get the last cached getApiTaxonomyViewLocation query argument:
          const cachedArgs = generated.util.selectCachedArgsForQuery(state, 'getApiTaxonomyViewLocation').at(-1);
          const locationId = cachedArgs?.locationId;

          if (locationId) {
            const patchResult = dispatch(
              generated.util.updateQueryData('getApiTaxonomyViewLocation', cachedArgs, (drafts) => {
                const { name } = body;
                drafts.forEach((draft) => {
                  if (draft.id === buildingComplexId) {
                    draft.name = name;
                  }
                });
                Object.assign(drafts, patch);
              }),
            );
            try {
              await queryFulfilled;
            } catch {
              patchResult.undo();
            }
          }
        },
        invalidatesTags: ['Taxonomy'],
      },

      getApiGlobalDeviceListOperationExport: {
        query: (request) => {
          return {
            params: request,
            url: `/api/global-device-list/operation/export`,
            method: 'GET',
            responseHandler: handleFileDownload,
            cache: 'no-cache',
          };
        },
        extraOptions: { skipTenantContext: true },
      },

      getApiGatewaysExport: {
        query: (request) => {
          return {
            params: request,
            url: `/api/gateways/export`,
            method: 'GET',
            responseHandler: handleFileDownload,
            cache: 'no-cache',
          };
        },
        extraOptions: { skipTenantContext: true },
      },

      postApiTaxonomyImport: {
        query: (request) => {
          const bodyFormData = new FormData();
          if (request.body.File) bodyFormData.append('File', request.body.File);

          return {
            url: '/api/taxonomy/import',
            method: 'POST',
            body: bodyFormData,
          };
        },
        invalidatesTags: ['Taxonomy', 'Location'],
      },

      postApiTaxonomyImportByProjectId: {
        query: (request) => {
          const bodyFormData = new FormData();
          if (request.body.File) bodyFormData.append('File', request.body.File);

          return {
            url: `/api/taxonomy/import/${request.projectId}`,
            method: 'POST',
            body: bodyFormData,
          };
        },
        invalidatesTags: ['Taxonomy', 'Location', 'ProjectBuildings', 'ProjectDetail', 'ProjectIssues'],
      },

      postApiTaxonomyImportValidate: {
        query: (request) => {
          const bodyFormData = new FormData();
          if (request.body.File) bodyFormData.append('File', request.body.File);

          return {
            url: '/api/taxonomy/import/validate',
            method: 'POST',
            body: bodyFormData,
          };
        },
      },

      postApiRentersImport: {
        query: (request) => {
          const bodyFormData = new FormData();
          if (request.body.File) bodyFormData.append('File', request.body.File);

          return {
            url: '/api/renters/import',
            method: 'POST',
            body: bodyFormData,
          };
        },
        invalidatesTags: ['RenterVerification', 'BuildingUnit'],
      },

      postApiRentersImportValidate: {
        query: (request) => {
          const bodyFormData = new FormData();
          if (request.body.File) bodyFormData.append('File', request.body.File);

          return {
            url: '/api/renters/import/validate',
            method: 'POST',
            body: bodyFormData,
          };
        },
      },

      postApiRentersBulkUpdate: {
        query: (request) => {
          const bodyFormData = new FormData();
          if (request.body.File) bodyFormData.append('File', request.body.File);

          return {
            url: '/api/renters/bulk-update',
            method: 'POST',
            body: bodyFormData,
          };
        },
        invalidatesTags: ['RenterVerification', 'BuildingUnit'],
      },

      postApiRentersBulkUpdateValidate: {
        query: (request) => {
          const bodyFormData = new FormData();
          if (request.body.File) bodyFormData.append('File', request.body.File);

          return {
            url: '/api/renters/bulk-update/validate',
            method: 'POST',
            body: bodyFormData,
          };
        },
      },

      postApiThermostatsAssignWithChecksAndImageByThermostatId: {
        query: (request) => {
          const bodyFormData = new FormData();
          const body = request.body;
          if (body.Image) bodyFormData.append('Image', body.Image);
          if (body.FileName != null) bodyFormData.append('FileName', body.FileName);
          if (body.RadiatorId != null) bodyFormData.append('RadiatorId', body.RadiatorId);
          if (body.ValvePinChecked != null) bodyFormData.append('ValvePinChecked', String(body.ValvePinChecked));
          if (body.ValveIsInPositionZero != null) bodyFormData.append('ValveIsInPositionZero', String(body.ValveIsInPositionZero));
          if (body.ValveCheckedForLeakage != null) bodyFormData.append('ValveCheckedForLeakage', String(body.ValveCheckedForLeakage));
          if (body.ThermostatMounted != null) bodyFormData.append('ThermostatMounted', String(body.ThermostatMounted));
          if (body.ThermostatTurnedOn != null) bodyFormData.append('ThermostatTurnedOn', String(body.ThermostatTurnedOn));

          return {
            url: `/api/thermostats/assign-with-checks-and-image/${request.thermostatId}`,
            method: 'POST',
            body: bodyFormData,
          };
        },
        invalidatesTags: [
          'InstallToolBuildingUnit',
          'InstallToolRadiator',
          'Radiator',
          'ThermostatAutocomplete',
          'Thermostat',
          'DevicePhoto',
        ],
      },

      postApiInstallToolByDeviceIdAndDeviceTypeImages: {
        invalidatesTags: ['DevicePhoto'],
        query: (request) => {
          const bodyFormData = new FormData();
          const images = request.body.images ?? [];
          images.forEach((image, index) => {
            // File part must include filename so [FromForm] List<ImageReadModel> binds correctly
            bodyFormData.append(`images[${index}].Image`, image.image, image.fileName);
            bodyFormData.append(`images[${index}].FileName`, image.fileName);
            bodyFormData.append(`images[${index}].Angle`, image.angle);
          });
          return {
            url: `/api/install-tool/${request.deviceId}/${request.deviceType}/images`,
            method: 'POST',
            body: bodyFormData,
          };
        },
      },

      postApiDevicesImagesByBuildingIdBulk: {
        query: (request) => {
          return {
            url: `/api/devices/images/${request.buildingId}/bulk`,
            method: 'POST',
            body: request.body,
            responseHandler: handleFileDownload,
            cache: 'no-cache',
          };
        },
      },

      getApiHeatingLoadByBuildingIdValidation: {
        keepUnusedDataFor: 0,
      },

      postApiRentersVerificationsOverrideByUserId: { invalidatesTags: ['RenterVerification'] },
      getApiRentersVerificationsBuildingUnitByBuildingUnitId: { providesTags: ['RenterVerification'] },
      getApiRentersVerificationsEmailByEmail: { providesTags: ['RenterVerification'] },
      getApiRentersVerificationsUsers: { providesTags: ['RenterVerification'] },

      // batches
      getApiDevelopmentDataTransferToDeviceBatches: { providesTags: ['DataTransferToDeviceBatches'] },
      postApiDevelopmentDataTransferToDeviceBatchesCreateCoreBatchByMajorAndMinorPatch: {
        invalidatesTags: ['DataTransferToDeviceBatches'],
      },
      postApiDevelopmentDataTransferToDeviceBatchesCreateAppBatchByAppIdAndMajorMinorPatch: {
        invalidatesTags: ['DataTransferToDeviceBatches'],
      },
      postApiDevelopmentDataTransferToDeviceBatchesAbortByBatchId: { invalidatesTags: ['DataTransferToDeviceBatches'] },
      getApiDevelopmentDataTransferToDeviceBatchesExportByBatchId: {
        query: (request) => {
          return {
            url: `/api/development/data-transfer-to-device/batches/export/${request.batchId}`,
            method: 'GET',
            responseHandler: handleFileDownload,
            cache: 'no-cache',
          };
        },
      },

      // Phases
      getApiDevelopmentDataTransferToDeviceBatchesPhaseByBatchId: { providesTags: ['Phase'] },
      postApiDevelopmentDataTransferToDeviceBatchesPhase: { invalidatesTags: ['Phase', 'DataTransferToDeviceBatches'] },
      postApiDevelopmentDataTransferToDeviceBatchesAbortByBatchIdPhaseAndPhaseId: { invalidatesTags: ['Phase'] },

      // Organizations
      getApiOrganizations: { providesTags: ['Organization'] },
      postApiOrganizations: { invalidatesTags: ['Organization'] },
      putApiOrganizationsByOrganizationId: { invalidatesTags: ['Organization'] },

      // Heating clamps
      getApiHeatingClampsByBuildingIdStatistics: { providesTags: ['HeatingClamps'] },
      getApiHeatingClampsByBuildingIdThermostats: { providesTags: ['HeatingClamps'] },
      putApiHeatingClamps: { invalidatesTags: ['HeatingClamps'] },
      putApiHeatingClampsDefault: { invalidatesTags: ['HeatingClamps'] },
    },
  });

export const {
  useGetApiGatewaysByGatewayIdQuery,
  useGetApiThermostatsByThermostatIdQuery,
  useGetApiThermostatsByThermostatIdConnectivityQuery,
  useGetApiThermostatsByThermostatIdLastmeasurementsQuery,
  useGetApiThermostatsByThermostatIdOperationalStatusQuery,
  useGetApiThermostatsByThermostatIdRenterQuery,
  useDeleteApiThermostatsByThermostatIdMutation,
  usePatchApiThermostatsByThermostatIdMutation,
  useGetApiThermostatsThermostatHistoryQuery,
  useGetApiThermostatsThermostatHistoryRadiatorsQuery,
  useGetApiThermostatsDownlinksQuery,
  useLazyGetApiThermostatsAssemblyLineHistoryByEuiQuery,
  usePostApiDevelopmentAssemblyLineSummaryMutation,
  usePostApiDevelopmentAssemblyLineDetailMutation,
  useGetApiAlertsThermostatsQuery,
  usePostApiThermostatsOperationsByThermostatIdDirectMotorControlDisableMutation,
  usePostApiThermostatsOperationsByThermostatIdDirectMotorControlEnableMutation,
  usePostApiThermostatsOperationsByThermostatIdFlushValveMutation,
  usePostApiThermostatsOperationsByThermostatIdManualCalibrationMutation,
  usePostApiThermostatsOperationsByThermostatIdMcuResetMutation,
  usePostApiThermostatsOperationsByThermostatIdDisplayRotationMutation,
  usePostApiThermostatsOperationsByThermostatIdMajorModeMutation,
  usePostApiThermostatsOperationsByThermostatIdMotorPositionConstraintMutation,
  usePostApiThermostatsOperationsByThermostatIdMotorPositionMutation,
  usePostApiThermostatsOperationsByThermostatIdTargetTemperatureMutation,
  usePostApiThermostatsOperationsByThermostatIdTargetTemperatureLevelMutation,
  usePostApiThermostatsOperationsByThermostatIdToggleActiveHarvestingAndActivateMutation,
  usePostApiThermostatsLifecycleTenantUnassignByThermostatEuiMutation,
  useGetApiDevicesByDeviceTypeImageAndImageIdQuery,
  useGetApiDevicesByDeviceTypeImageMetadataAndDeviceIdQuery,
  useDeleteApiGatewaysByGatewayIdMutation,
  usePatchApiGatewaysByGatewayIdMutation,
} = apiService;
